import React, { useState, useEffect, useContext } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { swalMessages, permitsList } from 'src/constants';
import { getUnidades } from 'src/services/insightService';
import { Context } from 'src/context/Contex';
import swal from 'sweetalert';
import Insight from 'src/pages/InsigthFactory/Insight/Insight';
import {
  getUrl,
  getFiles,
  getImage,
  postLike,
  postImage,
  postFiles,
  postDetail,
  getDetails,
  deleteFile,
  deleteInsight,
} from 'src/services/insightDetailsService';
import {
  postTestResults,
} from 'src/services/insightTestsServices';

const initialFormEdit = {
  titulo: '',
  resumen: '',
  detalle: '',
  indicadores: '',
};
const initialFormResult = {
  resultado: '',
  adjuntos: [],
};
const InsigthContainer = () => {
  const [files, setFiles] = useState([]);
  const [insight, setInsight] = useState({});
  const [unidades, setUnidades] = useState([]);
  const [openEdit, setOpenEdit] = useState(false);
  const [openResult, setOpenResult] = useState(false);
  const [formEdit, setFormEdit] = useState(initialFormEdit);
  const [formResult, setFormResult] = useState(initialFormResult);
  const [insightImg, setInsightImg] = useState({});

  const { id } = useParams();
  const history = useHistory();
  const { permisos } = useContext(Context);
  const permitValue = permisos[permitsList.FABRICA_INSIGHTS];

  const fetchInsight = async (insightId) => {
    const { object, success } = await getDetails(insightId);
    if (success) {
      setInsight(object);
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };

  const fetchFiles = async (insightId) => {
    const { success, data } = await getFiles(insightId);
    if (success) {
      setFiles(data);
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };

  const fetchImage = async (insightId) => {
    const { success, data } = await getImage(insightId);
    if (success) {
      setInsightImg(data);
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };

  const openNewTab = (url) => {
    const win = window.open(url, '_blank');
    win.focus();
  };

  const fetchUrl = async (index, urlFirmada) => {
    if (urlFirmada) {
      openNewTab(urlFirmada);
    } else {
      const idFile = files[index].id;
      const { success, object } = await getUrl(idFile);
      if (success) {
        openNewTab(object?.urlFirmada);
      } else {
        swal(swalMessages.GENERAL_ERROR);
      }
    }
  };

  const goBack = () => {
    history.push('/insight_factory');
  };

  const fetchUnidades = async () => {
    const { success, data } = await getUnidades();
    if (success) {
      setUnidades(data);
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };

  const onDeleteInsight = async () => {
    swal(swalMessages.DELETE_CONFIRM).then(async (willDelete) => {
      if (willDelete) {
        const { success } = await deleteInsight({
          id,
          tipo: 'eliminar',
        });
        if (success) {
          swal(swalMessages.SUCCEFUL_DELETE);
          history.push('/insight_factory');
        } else {
          swal(swalMessages.GENERAL_ERROR);
        }
      }
    });
  };

  const onEdit = () => {
    setOpenEdit(true);
    setFormEdit(insight);
  };

  const onCloseDialogs = () => {
    setOpenEdit(false);
    setOpenResult(false);
    setFormEdit(initialFormEdit);
    setFormResult(initialFormResult);
  };

  const onSubmitEdit = async (event) => {
    event.preventDefault();
    const { success } = await postDetail({
      id_entrada: id,
      tipo: 'detalle',
      titulo: formEdit.titulo,
      resumen: formEdit.resumen,
      detalle: formEdit.detalle,
      indicadores: formEdit.indicadores,
    });
    if (success) {
      swal(swalMessages.SUCCESSFUL_SEND);
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };

  const toBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

  const onChangeInputs = async (value, field) => {
    if (field === 'files') {
      const fileList = value[0];
      const name = fileList?.name;
      const base64 = await toBase64(fileList);
      const { success, data } = await postFiles({
        id_entrada: id,
        nombreAdjunto: name,
        adjunto: base64,
      });
      if (success) {
        const newfile = data
          .filter((file) => file.nombre_adjunto === name)
          .pop();
        setFiles([...files, newfile]);
      } else {
        swal(swalMessages.GENERAL_ERROR);
      }
    } else {
      setFormEdit({ ...formEdit, [field]: value });
    }
  };

  const handleDeleteFile = (index) => {
    const idFile = files[index].id;
    swal(swalMessages.DELETE_CONFIRM).then(async (willDelete) => {
      if (willDelete) {
        const { success } = await deleteFile(idFile);
        if (success) {
          const updatedFiles = files.filter((file) => file.id !== idFile);
          setFiles(updatedFiles);
        } else {
          swal(swalMessages.GENERAL_ERROR);
        }
      }
    });
  };

  const onOpenResult = () => {
    setOpenResult(true);
  };

  const onChangeResults = async (value, field) => {
    if (field === 'files') {
      const fileList = value[0];
      const nombreAdjunto = fileList?.name;
      const adjunto = await toBase64(fileList);
      const newFile = { nombreAdjunto, adjunto };
      setFormResult((prevState) => (
        { ...prevState, adjuntos: [...prevState.adjuntos, newFile] }));
    } else {
      setFormResult({ ...formResult, [field]: value });
    }
  };

  const onSubmitResult = async (event) => {
    event.preventDefault();
    const { success } = await postTestResults({
      id_entrada: id,
      ...formResult,
    });
    if (success) {
      fetchInsight(id);
      swal(swalMessages.SUCCESSFUL_MESSAGE);
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };
  const onDeleteFile = (index) => {
    const { nombreAdjunto } = formResult.adjuntos[index];
    const updateFiles = formResult.adjuntos.filter((adj) => adj.nombreAdjunto !== nombreAdjunto);
    setFormResult((prevState) => ({ ...prevState, adjuntos: updateFiles }));
  };

  const onLike = async (idTest, type) => {
    const { success, object } = await postLike({
      id_prueba: idTest,
      tipo: type,
    });
    if (success) {
      const { puntosTotales } = object;
      const newLike = insight.resultados.map((result) => {
        if (result.id === idTest) {
          return {
            ...result,
            puntos: puntosTotales,
          };
        }
        return result;
      });
      setInsight({ ...insight, resultados: newLike });
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };
  const onPostImage = async (value) => {
    const fileList = value[0];
    if (fileList) {
      const nombreAdjunto = fileList?.name;
      const adjunto = await toBase64(fileList);
      const { success } = await postImage({
        id_entrada: id,
        nombre_adjunto: nombreAdjunto,
        adjunto,
      });
      if (success) {
        fetchImage(id);
      } else {
        swal(swalMessages.GENERAL_ERROR);
      }
    } else {
      return false;
    }
  };

  useEffect(() => {
    fetchFiles(id);
    fetchInsight(id);
    fetchImage(id);
    fetchUnidades();
  }, []);

  return (
    <Insight
      files={files}
      onEdit={onEdit}
      goBack={goBack}
      onLike={onLike}
      insight={insight}
      openEdit={openEdit}
      unidades={unidades}
      formEdit={formEdit}
      fetchUrl={fetchUrl}
      formResult={formResult}
      openResult={openResult}
      permitValue={permitValue}
      onOpenResult={onOpenResult}
      onSubmitEdit={onSubmitEdit}
      onDeleteFile={onDeleteFile}
      onCloseDialogs={onCloseDialogs}
      onSubmitResult={onSubmitResult}
      onChangeInputs={onChangeInputs}
      onChangeResults={onChangeResults}
      onDeleteInsight={onDeleteInsight}
      handleDeleteFile={handleDeleteFile}
      onPostImage={onPostImage}
      insightImg={insightImg}
    />
  );
};

export default InsigthContainer;
